import React, { useEffect, useState, useContext } from 'react';
import { CardContent, CardHeader, Container, Expandable, IconsContainer, ContentTextArea, ButtonContent, TextArea } from './styles'
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Button, { ButtonContainer } from 'components/Button';
import { useHistory } from "react-router-dom";

const propTypes = {
  title: PropTypes.string.isRequired,
  idOperation: PropTypes.string.isRequired,
};
export default function NotesAccordion(props) {
  const [expanded, setExpanded] = useState(false);
  const [expanding, setExpanding] = useState(false);
  const [collapsing, setCollapsing] = useState(false);
  const [beforeCollapsing, setBeforeCollapsing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");
  const [notes, setNotes] = useState("");

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();

  const accordionState = (state) => {
    setExpanding(false);
    setCollapsing(false);
    setBeforeCollapsing(false);
    setExpanded(state);
  };

  const accordionAnimation = (state) => {
    setExpanded(false);
    if (state && !expanded) {
      setExpanding(true);
      setTimeout(() => accordionState(true), 100);
    } else if (!state && expanded) {
      setBeforeCollapsing(true);
      setTimeout(() => {
        setCollapsing(true);
        setTimeout(() => accordionState(false), 100)
      }, 10);
    }
  };

  function handleUpdateNotes() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationNotesUpdate(props.idOperation, props.idQuestion, value)
      .then(() => {
        setIsEditing(false);
        setValue("")
        handleGetNotes()
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleGetNotes() {
    if (props.idOperation) {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestOperationNotes(props.idOperation, props.idQuestion)
        .then(response => response.json()).then(data => {
          setNotes(data.ret_value.notes)
        })
        .catch((error) => {
          mc.error("There was an error while fetching your data: \n" + error);
          console.error('fitPostSummary - Error:', error);
        });
    }
  };

  useEffect(() => {
    handleGetNotes();
  }, [props.idOperation])

  return (
    <Container>
      <CardHeader >
        <div>
          {props.title}
        </div>
        <IconsContainer>
          <Icon
            name="folder"
            className="folder"
            onClick={() => history?.push(`/broking/document-management/${props.idOperation}`)}
          />
          <Icon
            name="add"
            className="icon-add"
            onClick={() => {
              setIsEditing(true)
              setExpanded(true)
            }}
          />
          <Icon
            className={(!expanded || collapsing) && !expanding ? 'closed' : ''}
            name="arrowup"
            onClick={() => accordionAnimation(!expanded)}
          />
        </IconsContainer>
      </CardHeader>
      <CardContent className={expanded ? 'expanded' : beforeCollapsing ? 'before-collapsing' : (collapsing ? 'collapsing' : (expanding ? 'expanding' : ''))} >
        <Expandable>
          <ContentTextArea>
            <TextArea
              value={isEditing ? value : notes}
              onChange={(e) => setValue(e.target.value)}
              disabled={!isEditing}
            />
            {isEditing
              ? (
                <ButtonContainer style={{ justifyContent: 'flex-end' }}>
                  <ButtonContent>
                    <Button
                      id="btnLost"
                      onClick={() => {
                        setIsEditing(false)
                        setValue("")
                      }}
                      third
                    >
                      {"CANCELAR"}
                    </Button>

                    <Button
                      id="btnSave"
                      type="submit"
                      onClick={() => handleUpdateNotes()}
                      primary
                    >
                      SALVAR
                    </Button>
                  </ButtonContent>
                </ButtonContainer>
              ) : null
            }

          </ContentTextArea>
        </Expandable>
      </CardContent>
    </Container>
  );
}

NotesAccordion.propTypes = propTypes;